export default __webpack_public_path__ + "static/media/mintBg.cf01cd05.jpg";